import script from "./HotelReservationCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelReservationCreate.vue?vue&type=script&setup=true&lang=js"

import "./HotelReservationCreate.vue?vue&type=style&index=0&id=bf1a8292&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf1a8292"]])

export default __exports__